// A module may restrict itself to specific application roles (Admin Platform → admin only).
// Modules without a roles list keep the existing role policy.
export function isModuleAllowedForRole(module, role) {
  const roles = module && Array.isArray(module.roles) ? module.roles : null;
  return !roles || roles.length === 0 || roles.includes(role);
}
